<template>
  <div class="sp-tab-menu h-full">
    <ul class="list-none h-full">
      <el-scrollbar wrap-style="overflow-x:hidden;" class="h-full">
        <li v-for="(menu, index) in menus" :key="index" :class="{ 'is-active' : index === value }" class="menu-item" @click="$emit('update:value', index)">
          <span :title="menu.label" class="menu-item-label w-full truncate">{{ menu.label }}</span>
        </li>
      </el-scrollbar>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SpTabMenu',
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    menus: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style/index.scss';
.sp-tab-menu {
  border-right: 1px solid #e4e7ed;
  > ul {
    padding: 0;
    margin: 0;
    .menu-item {
      padding: 0 20px;
      width: 100%;
      height: 40px;
      box-sizing: border-box;
      line-height: 40px;
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      position: relative;
      cursor: pointer;
      border-radius: 8px;
      &:hover {
        color: #409eff;
      }
      &.is-active {
        color: #409eff;
        background-color: rgba(64, 158, 255, .1);
        font-weight: 700;
      }
      .menu-item-label {
        color: inherit;
        font-size: inherit;
        display: inline-block;
      }
    }
  }
}
</style>
